module.exports = __webpack_public_path__ + "img/middleD.af255df9.png";